import { render } from "./edit-international.vue?vue&type=template&id=70651fd4&ts=true"
import script from "./edit-international.vue?vue&type=script&lang=ts"
export * from "./edit-international.vue?vue&type=script&lang=ts"

import "./edit-international.vue?vue&type=style&index=0&id=70651fd4&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__